// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Fabelwesen „Fuchs": sitzt, rutscht hoch, wedelt zweimal, blinzelt einmal.
export default function Fuchs() {
  return (
    <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
      <g
        className="fuchs"
        fill="none"
        stroke="var(--tanne)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Gräser */}
        <path d="M16 102 q4 -8 2 -16 M22 102 q-2 -7 2 -12" stroke="var(--moos)" />
        {/* Schwanz */}
        <g className="fuchs-schwanz">
          <path d="M76 98 C98 100 112 84 108 62 C98 76 90 82 78 86 Z" fill="var(--sand)" />
        </g>
        {/* Körper, sitzend */}
        <path d="M42 100 C36 82 42 64 58 56 L70 62 C80 72 82 88 80 100 Z" fill="var(--creme)" />
        {/* Vorderpfoten */}
        <path d="M52 100 L52 88 M62 100 L62 90" />
        {/* Kopf */}
        <g className="fuchs-kopf">
          {/* Ohren */}
          <path d="M40 34 L36 14 L54 26 Z" fill="var(--sand)" />
          <path d="M76 34 L80 14 L62 26 Z" fill="var(--sand)" />
          {/* Gesicht */}
          <path d="M38 32 C34 46 44 58 58 58 C72 58 82 46 78 32 C72 24 44 24 38 32 Z" fill="var(--sand)" />
          {/* Nase */}
          <circle cx="58" cy="52" r="2.5" fill="var(--tanne)" stroke="none" />
          {/* Augen (blinzeln) */}
          <g className="fuchs-augen">
            <circle cx="48" cy="42" r="2.5" fill="var(--tanne)" stroke="none" />
            <circle cx="68" cy="42" r="2.5" fill="var(--tanne)" stroke="none" />
          </g>
        </g>
      </g>
    </svg>
  )
}
